import { withStyles } from '@material-ui/core';
import React, { useContext } from 'react';
import DataContext from '../data/DataContext';
import Header from '../chat/Header';
import Chat from '../chat/Chat';
import AutoComplete from '../chat/AutoComplete';
import Footer from '../chat/Footer';
import CustomerFeedback from '../dialog/CustomerFeedback';
import Loading from './Loading';

const styles = (theme) => ({
  chat: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: '2.875rem',
    bottom: '0px',
    background: theme.color.background,
  },
});

const Layout = (props) => {
  const { classes } = props;
  const data = useContext(DataContext);

  return data.conversationStart ? (
    <>
      <Header />
      <div className={classes.chat}>
        <Chat />
        <Footer />
        <AutoComplete />
      </div>
      <CustomerFeedback />
    </>
  ) : (
    <Loading safari={data.userAgent.os === 'iOS'} />
  );
};

export default withStyles(styles)(Layout);
